import { useSelector } from 'react-redux'
import { selectAuthData } from '@/containers/Login/AuthSelectors'

const useLeftMenuRedesign = (): boolean => useSelector(selectAuthData)?.commonData?.leftMenuRedesignEnabled === true

export default useLeftMenuRedesign
